var _style, _polygon, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGameHover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 296.8 202.9",
    style: {
      enableBackground: "new 0 0 296.8 202.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#0A0368;}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 201.4064,
    y1: 749.8176,
    x2: 201.4064,
    y2: 552.9199,
    gradientTransform: "matrix(-1 0 0 -1 349.8128 754.3939)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F8E800"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E7B500"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "0,0 296.8,0 296.8,202.9 0,202.9 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M116,109l5.7,0.7c0,0,0.1,0,0.1,0l12.7,1.6c0.2,0,0.4,0.2,0.3,0.5c0,0.2-0.2,0.4-0.5,0.5l-13,1.5 c0,0-0.2,1.3-0.3,1.7c-0.3,1.6-0.6,3.1-0.8,4.7l0,0l-2.3,12.6c0,0.1,0,0.1,0,0.2l0,0l-0.5,3l0.6,0c0,0,0.8,0,1.5-0.4l66.8-33.3l0,0 c0.8-0.4,0.3-0.8,0.2-0.9l0,0c0,0,0,0,0,0l0,0l-55.2-34.2c-0.7-0.4-1.6-0.4-1.6-0.4l-0.1,0l-2.8,15.6l0,0l-1.1,6.1l-15.9,1.8l0.2,0 c-0.2,0.1-0.2,0.5,0.1,0.5l32.7,3.5l3.8,0.5c0.2,0,0.4,0.2,0.3,0.5c0,0.2-0.2,0.4-0.5,0.5l-22.4,2.6l-0.2,1 c-0.3,1.6-0.6,3.2-0.9,4.9c-0.2,0.9-0.3,1.8-0.5,2.8l-9.5,1.1c-0.4,0-0.4,0.6-0.1,0.6L116,109L116,109z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameHover);
export default __webpack_public_path__ + "static/media/game-hover.4e9b8f9fe6bb193d96b72167d4a0a7f0.svg";
export { ForwardRef as ReactComponent };